// PROD-2743 · the design sheet v1.1 on the app screens (dashboard, patients, chart, settings,
// notifications). ON for everyone since 2 Nov (encounter-flags.ts); OFF only behind the developer
// fallback `?x=frame-1` on the dev host, where each screen renders as it did before this hook existed.
//
// Read once per mount (the same pattern as `encounter-shell-page.tsx`), so a screen never flips
// look half-way through a render tree.
import { useState } from 'react';
import { isEncounterFlagOn } from './encounter-flags';

// `ownSwitchOnly` matters only with the encounter defaults pinned off (tests); otherwise frameV2 is ON here as in the encounter.
export function useFrameV2(): boolean {
  const [on] = useState(() => isEncounterFlagOn('frameV2', { ownSwitchOnly: true }));
  return on;
}
